<div [class]="skinName">
  @if (!voucherSuccessPage) {
    <h2 class="uk-modal-title">
    {{ configService.localeKeys?.['account.redeem_code.text'] }}</h2>
  }
  @if (!voucherSuccessPage && step==1) {
    <div class="input-container">
      @if (!voucherSuccessPage && ((myAccountData.is_subscription_applied == 0) && (myAccountData.user_telco == ''))) {
        <p class="mobile-p">{{ configService.localeKeys?.['voucher.enter_your_code.text'] }}</p>
      }
      @if (!voucherSuccessPage && ((myAccountData.is_subscription_applied != 0) || (myAccountData.user_telco != ''))) {
        <p class="mobile-p">{{configService.localeKeys?.user_cant_redeem_another_voucher_apps }}</p>
      }
      <form method="post" id="voucher" enctype="multipart/form-data">
        <div class="voucher-input-fields form-group">
          <!-- <span class="voucher-label" *ngIf="!errorMsg && !voucherReq">{{ configService.localeKeys?.['account.voucher_code.text'] }}</span> -->
          <label class="input-label">{{ configService.localeKeys?.['account.voucher_code.text'] }} </label>
          @if ((myAccountData.is_subscription_applied == 0) && (myAccountData.user_telco == '')) {
            <input id="voucher_code" (keydown)="updateMsg()" (ngModelChange)="resetErrorMsg()" [(ngModel)]="voucher_code" [ngModelOptions]="{standalone: true}" name="voucher_code" class="form-control" [ngClass]="errorMsg ? 'errorInput' : ''" placeholder="{{ configService.localeKeys?.['voucher.enter_voucher_code.text']}}"
              type="text" required>
          }
          @if (((myAccountData.is_subscription_applied != 0) || (myAccountData.user_telco != ''))) {
            <input id="voucher_code" readonly (keydown)="updateMsg()" (ngModelChange)="resetErrorMsg()" [(ngModel)]="voucher_code" [ngModelOptions]="{standalone: true}" name="voucher_code" class="form-control" [ngClass]="errorMsg ? 'errorInput' : ''" placeholder="{{ configService.localeKeys?.['voucher.enter_voucher_code.text']}}"
              type="text" required>
          }
          @if (errorMsg) {
            <span class="error-block">{{ errorMsg }}</span>
          }
          @if (voucherReq) {
            <span class="error-block">{{ configService.localeKeys?.['voucher.code_required.text'] }}</span>
          }
        </div>
        @if (!voucherContent && ((myAccountData.is_subscription_applied == 0) && (myAccountData.user_telco == ''))) {
          <button class="uk-button submit-btn" (click)="validateVoucherHelper()">{{ configService.localeKeys?.['voucher.redeem_voucher.text']}}</button>
        }
        @if (!voucherContent && ((myAccountData.is_subscription_applied != 0) || (myAccountData.user_telco != ''))) {
          <button class="uk-button submit-btn" disabled>{{ configService.localeKeys?.['voucher.redeem_voucher.text']}}</button>
        }
        @if (voucherContent) {
          <div class="voucher-success">
            <div class="voucher-title">{{ configService.localeKeys?.['voucher.code_entitles.text'] }}</div>
            <div class="voucher-msg">{{ voucherSuccess }}</div>
            <button class="uk-button submit-btn" (click)="voucher_apply()"> {{ configService.localeKeys?.['voucher.activate_voucher.btn']}}</button>
          </div>
        }
        <div id="help"><u class="help-list">
          <div class="ml-3 f-12 text-center">
            <app-footer-link [footerKey]="'faq'"
              [footerNavText]="configService.localeKeys['help_voucher'] || 'Do you need any help with voucher?'">
            </app-footer-link>
          </div>
        </u></div>
      </form>
    </div>
  }

  @if (voucherSuccessPage && step==1) {
    <div class="input-container">
      <h2 class="uk-modal-title mobile-none">{{ configService.localeKeys?.['plans.success.text']}}</h2>
      <app-success [redeemWatchBtn]="true" [hasHeaderTitle]="true"  [toptext]="message" icon="/branding/theme/assets/static_assets/ic-success.svg" [bottomtext]="successDesc" [haslottie]="'true'">
      </app-success>
    </div>
  }
  @if (step==2) {
    <div class="input-container">
      <app-select-plan  (emitStep)="getSignStep($event)" [type]="'redeemCoupon'" [paymentTypes]="paymentMethods" (emitSelectPlan)="selectedPlan($event)" [oldUser]="checkout_session_id" [discountFlag]="true"></app-select-plan>
    </div>
  }

  @if (step==3) {
    <div id="payment-method" class="form-card">
      <!-- <app-payment-method (emitCardMethod)="cardMethod($event)" [auth_head]="false"></app-payment-method> -->
      <app-payment-method-type class="common-bg" [type]="'redeemCoupon'" (emitStep)="getSignStep($event)" (emitCardMethod)="cardMethod($event)" [coupon_valid]="coupon_valid"></app-payment-method-type>
    </div>
  }
  @if (step==4) {
    <div id="payment-card" class="form-card">
      <!-- <div [ngClass]="selectPlan.oldUser ? 'subTitleTopPad' : 'subTitleBotPad'" id="pay-sub-title">{{ configService.localeKeys?.['plans.set_up_your_payment.text'] }}</div> -->
      <app-signup-step [backRoute]="accountPageUrl" (emitStep)="getSignStep($event)" [currentStep]="paymentMethodLength > 1 ? '4' : '3'" [showChangePlan]="true"></app-signup-step>
      <app-plan-info [hidden] = "payment_type ==='ideal'" [showIntent]="true"></app-plan-info>
      <app-card-payment [hidden] = "payment_type!='card'"  (emitCardPayment)="cardPayment($event)" [payButton]="false" [coupon_valid]="coupon_valid" #selectPlan></app-card-payment>
      <!-- <app-ideal-payment [hidden] = "payment_type!='ideal'"  (emitIdealPayment)="idealPayment($event)"></app-ideal-payment> -->
      <app-plan-info [idealBankValidationText]="true" [hidden] = "payment_type!='ideal'" [showIntent]="true"></app-plan-info>
      <app-ideal-payment-bank [hidden] = "payment_type!='ideal'"  (emitIdealPayment)="idealPayment($event)" [enableIdealPayment]="true"></app-ideal-payment-bank>
    </div>
  }
  @if (step==5 && coupon_valid) {
    <div>
      <h2 class="uk-modal-title mobile-none">{{ successMessage.mainText }}</h2>
      <app-success [redeemWatchBtn]="true"  [toptext]="" icon="/branding/theme/assets/static_assets/ic-success.svg" [bottomtext]="successMessage.subText" [haslottie]="'true'">
      </app-success>
    </div>
  }
  @if (step==5 && !coupon_valid) {
    <div id="pay-success">
      <app-account-created [paymentDialog]="paymentDialog" [btnText]="configService.localeKeys?.['welcome.start_watching.text']"
      [subTitleText]="VoucherNotAppliedMsg"></app-account-created>
    </div>
  }

</div>